import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'confirm-delete-lookup',
  templateUrl: './confirm-delete-lookup.component.html',
  styleUrls: ['./confirm-delete-lookup.component.scss']
})
export class ConfirmDeleteLookupComponent implements OnInit {
  @Input() deleteTitle: string;
  @Input() deleteMessage: string;

  @Output() yes: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancel: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  errorMessage: string = "";

  constructor() { }

  ngOnInit() {
  }

  public addError (message: string) {
    this.errorMessage = message;
  }

  onYesClick() {
    this.yes.emit(true);
  }

  onCancelClick() {
    this.cancel.emit(false);
  }

  hasError() {
    return this.errorMessage.length > 0;
  }

}
